module.exports = __webpack_public_path__ + "img/my_active.e4de3481.png";